import { ISymbolLpFilterStore } from './controllerSymbolLp.interface';

export const symbolLpFilterInitialState: ISymbolLpFilterStore = {};
